// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

type SelectedZoneFilterType = 'ALL' | 'ZONES_FOR_SELECTED_TOURS';
type TourClusterType = 'ALL_TOURS' | 'VISIBLE_TOURS';
export type MapControlsModelType = {
    showMarkers: boolean,
    markerType: string,
    drivingRoute: boolean,
    aerialRoute: boolean,
    clusters: boolean,
    polygon: boolean,
    showZones: boolean,
    selectedZoneFilter: SelectedZoneFilterType,
    showUnassignedMarkers: boolean,
    showPolygonClustersFor: TourClusterType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class MapControls extends ImmutableModel {
    static fromJS(json: MapControlsModelType): MapControls {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): MapControlsModelType {
        return {
            showMarkers: this.showMarkers,
            markerType: this.markerType,
            drivingRoute: this.drivingRoute,
            aerialRoute: this.aerialRoute,
            clusters: this.clusters,
            polygon: this.polygon,
            showZones: this.showZones,
            selectedZoneFilter: this.selectedZoneFilter,
            showUnassignedMarkers: this.showUnassignedMarkers,
            showPolygonClustersFor: this.showPolygonClustersFor
        };
    }

    get showMarkers(): boolean {
        return this._state.get('showMarkers');
    }

    setShowMarkers(showMarkers: boolean): this {
        return this.clone(this._state.set('showMarkers', showMarkers));
    }

    get markerType(): string {
        return this._state.get('markerType');
    }

    setMarkerType(markerType: string): this {
        return this.clone(this._state.set('markerType', markerType));
    }

    get drivingRoute(): boolean {
        return this._state.get('drivingRoute');
    }

    setDrivingRoute(drivingRoute: boolean): this {
        return this.clone(this._state.set('drivingRoute', drivingRoute));
    }

    get aerialRoute(): boolean {
        return this._state.get('aerialRoute');
    }

    setAerialRoute(aerialRoute: boolean): this {
        return this.clone(this._state.set('aerialRoute', aerialRoute));
    }

    get clusters(): boolean {
        return this._state.get('clusters');
    }

    setClusters(clusters: boolean): this {
        return this.clone(this._state.set('clusters', clusters));
    }

    get polygon(): boolean {
        return this._state.get('polygon');
    }

    setPolygon(polygon: boolean): this {
        return this.clone(this._state.set('polygon', polygon));
    }

    get showZones(): boolean {
        return this._state.get('showZones');
    }

    setShowZones(showZones: boolean): this {
        return this.clone(this._state.set('showZones', showZones));
    }

    get selectedZoneFilter(): SelectedZoneFilterType {
        return this._state.get('selectedZoneFilter');
    }

    setSelectedZoneFilter(selectedZoneFilter: SelectedZoneFilterType): this {
        return this.clone(
            this._state.set('selectedZoneFilter', selectedZoneFilter)
        );
    }

    get showUnassignedMarkers(): boolean {
        return this._state.get('showUnassignedMarkers');
    }

    setShowUnassignedMarkers(showUnassignedMarkers: boolean): this {
        return this.clone(
            this._state.set('showUnassignedMarkers', showUnassignedMarkers)
        );
    }

    get showPolygonClustersFor(): TourClusterType {
        return this._state.get('showPolygonClustersFor');
    }

    setShowPolygonClustersFor(showPolygonClustersFor: TourClusterType): this {
        return this.clone(
            this._state.set('showPolygonClustersFor', showPolygonClustersFor)
        );
    }
}
